import { AssessmentCriteria } from '@/models/Assessment';

export const adaptCriteriaFormToDTO = (
  criterion: Partial<AssessmentCriteria>,
  index: number,
): Partial<AssessmentCriteria> => ({
  name: criterion.name,
  description: criterion.description,
  maxGrade: criterion.maxGrade,
  order: index + 1,
  activityType: criterion.activityType || null,
});
